import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const teacherProfileSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, VALIDATION_MESSAGES.addTeacher.name.required)
    .min(2, VALIDATION_MESSAGES.addTeacher.name.min)
    .max(100, VALIDATION_MESSAGES.addTeacher.name.max),

  phone: z.string().trim().min(1, VALIDATION_MESSAGES.mobileNumber.required),

  countryCode: z.string().optional(),
});

export type TTeacherProfileForm = z.infer<typeof teacherProfileSchema>;
